import axios from "axios";

import { URL, getUrl } from "@api/constants";

class VideoClient {
  
  search(deviceSerial, from, to) {
    return axios.post(getUrl(URL.POST_VIDEO_SEARCH), {
      deviceSerial,
      from,
      to
    });
  }

  download(deviceSerial, files) {
    return axios.post(getUrl(URL.POST_VIDEO_DOWNLOAD), {
      deviceSerial,
      files
    });
  }

  requestLiveStream(deviceSerial, channels) {
    return axios.post(getUrl(URL.POST_VIDEO_LIVE), {
      deviceSerial,
      channels
    });
  }
  
}

export let videoClient = new VideoClient();



// WEBPACK FOOTER //
// ./src/api/video.js